const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/chats",
  },
  actions: {
    list({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getById({ dispatch, state }, id) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/${id}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    reply({ dispatch, state }, { id, message }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/${id}/reply`,
          method: "POST",
          data: { message },
        },
        { root: true }
      );
    },
  },
};
